import HeaderTitleContent from "../../../../common/components/atom/HeaderTitleContent/HeaderTitleContent";
import SingleMinigrid from "../../../../features/minigrid/components/SingleMinigrid";



export default function SingleMinigridUpdatePage() {
  return (
    <>
    <HeaderTitleContent withGoBackBtn goBackBtnLabel="Retour">
    <SingleMinigrid.Title />
    </HeaderTitleContent>
    <SingleMinigrid.UpdateForm />
    </>
  )
}
